// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bpSU4{padding-bottom:16px}.PMjwn{display:flex;flex-direction:column;gap:8px;align-items:center}.zueI3{height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `bpSU4`,
	"topCard": `PMjwn`,
	"chart": `zueI3`
};
export default ___CSS_LOADER_EXPORT___;
